// src/helpers/adminTicketsService.js
import { get } from './apiHelper';

const adminTicketsService = {
  /**
   * Analiza discrepancias de puntos en tickets
   * @param {string} clienteId - ID del cliente a analizar (opcional)
   * @returns {Promise<Object>} Reporte de discrepancias encontradas
   */
  analyzePointsDiscrepancies: async (clienteId = null) => {
    try {
      const url = clienteId
        ? `tickets/admin/analyze-points-discrepancies?clienteId=${clienteId}`
        : 'tickets/admin/analyze-points-discrepancies';
      
      return await get(url);
    } catch (error) {
      console.error('Error analyzing points discrepancies:', error);
      throw error;
    }
  },
};

export default adminTicketsService;

